import { Title, TitleSection, Wrapper } from "../Properties/Details/styles";
import ProductCategories from "./ProductCategory";

export default function MarketplaceResource() {
  return (
    <Wrapper>
      <TitleSection>
        <Title> Marketplace Resource Management </Title>
      </TitleSection>
      <ProductCategories />
    </Wrapper>
  );
}
